export default __webpack_public_path__ + "static/media/torta.8cb17500.png";